import React, { MutableRefObject } from 'react';
import { Link } from '@opengov/component-library';
import { LocaleText } from '../../../../locale';
import type { ZeroRowsStatusBarSetter } from '../ZeroRowsStatusBar';

interface ZeroRowsStatusBarParams {
  setterRef: MutableRefObject<ZeroRowsStatusBarSetter | null>;
  inEditMode: boolean;
  canEditReport: boolean;
  suppressZerosInRows: boolean;
  localeText: LocaleText['multidataset'];
  hasParentData: boolean | null;
  onClickEditReport: () => void;
  setShowFormattingModal: (show: boolean) => void;
}

export function useZeroRowsStatusBar({
  setterRef,
  inEditMode,
  canEditReport,
  suppressZerosInRows,
  localeText,
  hasParentData,
  onClickEditReport,
  setShowFormattingModal
}: ZeroRowsStatusBarParams) {
  if (hasParentData === null) return;

  const setText = setterRef.current;
  if (!setText || !suppressZerosInRows) return;

  const onClick = () => {
    onClickEditReport();
    setShowFormattingModal(true);
  };

  if (inEditMode || !hasParentData) {
    setText('');
  } else if (canEditReport && hasParentData) {
    const formattingModalLink = <Link.Standard as="a" onClick={onClick} text={localeText.zeroRows.editorLink} />;
    setText(
      <>
        {localeText.zeroRows.editor} {formattingModalLink}.
      </>
    );
  } else {
    setText(localeText.zeroRows.viewer);
  }
}
